import { render, staticRenderFns } from "./AutomateItemsSelection.vue?vue&type=template&id=7b66f19b"
import script from "./AutomateItemsSelection.vue?vue&type=script&lang=js"
export * from "./AutomateItemsSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports